import {
	SERVER_GET_ADMIN_RESPONSIBILITIES,
	SET_ADMIN_RESPONSIBILITIES,
	SERVER_GET_RESPONSIBILITY_AREA_DATA,
	SET_RESPONSIBILITY_AREA_DATA,
	SERVER_GET_UPDATED_RESPONSIBILITY_AREA_RESPONSIBLES,
	SET_UPDATED_RESPONSIBILITY_AREA_RESPONSIBLES,
	UPDATE_RESPONSIBILITY_AREA_DATA,
	SERVER_UPDATE_RESPONSIBILITY_AREA_DATA,
	SIGNOUT_USER
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	areas: [],
	loading: {
		areas: false,
		areaData: false,
		updateResponsibilities: false
	},
	selectedAreaData: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_ADMIN_RESPONSIBILITIES:
			return {
				...state,
				areas: action.payload.areas,
				loading: {
					...state.loading,
					areas: false
				}
			};
		case SET_RESPONSIBILITY_AREA_DATA:
			return {
				...state,
				selectedAreaData: action.payload.areaData,
				loading: {
					...state.loading,
					areaData: false
				}
			};
		case SET_UPDATED_RESPONSIBILITY_AREA_RESPONSIBLES:
			return {
				...state,
				selectedAreaData: state.selectedAreaData.map(area =>
					area.areaId === action.payload.areaId
						? {
								...area,
								responsibleOrganisation: action.payload.responsibleOrganisation
						  }
						: area
				)
			};
		case UPDATE_RESPONSIBILITY_AREA_DATA:
			return {
				...state,
				loading: { ...state.loading, updateResponsibilities: false },
				areas: state.areas.map(area => {
					const updatedArea = action.payload.areas.find(element => element.areaId === area.areaId);
					return updatedArea ? { ...area, ...updatedArea } : area;
				})
			};
		case SERVER_GET_ADMIN_RESPONSIBILITIES:
			return {
				...state,
				loading: { ...state.loading, areas: true }
			};
		case SERVER_GET_RESPONSIBILITY_AREA_DATA:
			return {
				...state,
				loading: {
					...state.loading,
					areaData: true
				}
			};
		case SERVER_UPDATE_RESPONSIBILITY_AREA_DATA:
			return {
				...state,
				loading: { ...state.loading, updateResponsibilities: true }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/AdminResponsibilities.js